module.exports = __webpack_public_path__ + "img/logoMonOrientestV.06eb8750.svg";